export const PRICE = '23 USD'

export const BRAND = 'Hair Instructor Ready™'

/** Section 2 — real interior pages, in this exact order. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/iV6mxiub9N1hDDYE9r6AtX/p28-28.jpg',
    caption: 'Bridal Style Breakdown Map — Page 28',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mABNfPM7J5pu551T7EUYTv/p23-23.jpg',
    caption: 'Textured Updo Construction Sequence — Page 23',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qJSoEwXhQLBX78mkdqAF9M/p37-37.jpg',
    caption: 'Technique Combination Map — Page 37',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7TkR8sdhUpAkmdPBQUBXB8/p19-19.jpg',
    caption: 'One Foundation — Three Bun Looks — Page 19',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cQsNXkvyENe8pvDA1qpMWk/p13-13.jpg',
    caption: 'Wave Finish Comparison — Page 13',
  },
]

/** Section 3 — pain points. */
export const painPoints = [
  { title: 'Hours Preparing Lessons', text: 'Searching for the right material before every class.' },
  {
    title: 'Resources Everywhere',
    text: 'Notes, screenshots, PDFs and saved videos scattered across different places.',
  },
  {
    title: 'Complex Techniques to Explain',
    text: "Knowing how to do something doesn't automatically make it easy to teach.",
  },
  {
    title: 'Creating Everything Yourself',
    text: 'Activities, demonstrations, assessments and teaching resources — again and again.',
  },
]

/** Section 5 — the six volumes. Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Hairdressing Foundations & Professional Essentials',
    description:
      'Hair structure, analysis, professional tools, consultation, sectioning and the essential foundations students need before advancing.',
    accent: '#F3EBDD',
  },
  {
    number: 2,
    title: 'The Professional Hair Cutting System',
    description:
      'Cutting lines, guidelines, elevation, overdirection, graduation, layers, face framing, refinement and professional cutting logic.',
    accent: '#F4D3CC',
  },
  {
    number: 3,
    title: 'Hair Color Theory & Professional Application',
    description:
      'Color theory, levels, tones, underlying pigment, neutralization, formulation thinking, highlights, balayage and color troubleshooting.',
    accent: '#D5E0CC',
  },
  {
    number: 4,
    title: 'Blow-Dry, Styling & Finishing Techniques',
    description:
      'Blow-drying, brush control, thermal styling, curls, waves, volume, texture and professional finishing.',
    accent: '#D5E1EE',
  },
  {
    number: 5,
    title: 'Advanced Styling, Updos & Salon Techniques',
    description:
      'Braids, ponytails, buns, chignons, advanced waves, textured updos, bridal-inspired styling and professional style construction.',
    accent: '#E3D9EF',
  },
  {
    number: 6,
    title: 'The Hair Instructor Teaching & Assessment Toolkit',
    description:
      'Class structure, demonstrations, student practice, feedback, assessments, progress tracking and professional instructor tools.',
    accent: '#F2DFC6',
  },
]

export const volumeFlow = [
  'Foundations',
  'Cutting',
  'Color',
  'Styling',
  'Advanced Styling',
  'Teaching',
]

/** Section 6 — visual resources included. */
export const visualResources = [
  'Head maps',
  'Technique diagrams',
  'Step-by-step sequences',
  'Cutting geometry',
  'Color theory visuals',
  'Sectioning maps',
  'Curl & wave directions',
  'Updo construction',
  'Correct vs. incorrect examples',
  'Troubleshooting guides',
]

/** Section 7 — the five bonuses. */
export const bonuses = [
  {
    number: 'Bonus #1',
    title: 'The Ready-to-Teach Hairdressing Lesson Plan Vault',
    description:
      'Done-for-you lesson plans covering foundations, cutting, color, styling and advanced techniques.',
    badge: 'Lessons Already Planned',
    accent: '#F4D3CC',
  },
  {
    number: 'Bonus #2',
    title: 'The Hairdressing Student Practice & Worksheet Vault',
    description: 'Ready-to-use student worksheets, visual exercises, skill drills and practice activities.',
    badge: 'Student Materials Ready',
    accent: '#D5E0CC',
  },
  {
    number: 'Bonus #3',
    title: 'The Hairdressing Assessment & Certification Toolkit',
    description: 'Practical assessments, grading rubrics, progress tracking and course-completion resources.',
    badge: 'Assessments Ready',
    accent: '#D5E1EE',
  },
  {
    number: 'Bonus #4',
    title: 'The Hairdressing Visual Teaching Atlas',
    description: 'Professional diagrams, head maps, technique charts and visual reference guides.',
    badge: 'Visuals Ready',
    accent: '#E3D9EF',
  },
  {
    number: 'Bonus #5',
    title: 'The Hair Instructor Classroom & Student Management System',
    description:
      'Student records, attendance, training logs, class organization and instructor management tools.',
    badge: 'Classroom Organized',
    accent: '#F2DFC6',
  },
]

/** Section 8 — before and after. */
export const withoutSystem = [
  'Search for teaching material',
  'Save random screenshots',
  'Build explanations from scratch',
  'Create student activities',
  'Prepare assessments',
  'Organize everything yourself',
]

export const withSystem = [
  'Choose your topic',
  'Open the relevant volume',
  'Use visual teaching resources',
  'Give students structured practice',
  'Assess their progress',
  'Start teaching',
]

/** Section 9 — who it is for. */
export const audience = [
  'Hair Instructors',
  'Hair Educators',
  'Hairdressing Teachers',
  'Hair Academy Owners',
  'Salon Trainers',
  'Independent Hair Educators',
]

/** Section 10 — value stack. */
export const offerIncludes = [
  '6 Professional Hairdressing Teaching Volumes',
  'Ready-to-Teach Lesson Plan Vault',
  'Student Practice & Worksheet Vault',
  'Assessment & Certification Toolkit',
  'Visual Teaching Atlas',
  'Classroom & Student Management System',
]

/** Section 11 — what one resource saves. */
export const onePartItems = [
  "One cutting diagram you don't have to create.",
  "One lesson you don't have to plan.",
  "One worksheet you don't have to build.",
  "One assessment you don't have to prepare.",
]

export const faqs = [
  {
    question: 'Is this for beginner hairdressers?',
    answer:
      'No. Hair Instructor Ready™ is primarily designed for hair instructors, educators, teachers, salon trainers and academy owners who teach hairdressing.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. This is a digital product with instant access.',
  },
  {
    question: 'What topics are included?',
    answer:
      'The system covers hairdressing foundations, professional cutting, color theory and application, blow-drying and styling, advanced styling and instructor teaching tools.',
  },
  {
    question: 'Can I use this if I teach independently?',
    answer:
      'Yes. The resources are designed for independent educators, salon trainers and academy environments.',
  },
  {
    question: 'Are the materials brand-specific?',
    answer:
      'No. The technical education is designed to remain broadly applicable and brand-neutral where appropriate.',
  },
  {
    question: 'Are these editable Word documents?',
    answer:
      'No. The system consists of finished digital resources designed to be viewed and used without requiring Word or editable files.',
  },
  {
    question: 'Do I get access immediately?',
    answer: 'Yes. Access is delivered digitally after purchase.',
  },
  {
    question: 'Is the payment secure?',
    answer:
      'Yes. Checkout is secure and encrypted, and your payment is processed in your local currency.',
  },
]
